export default __webpack_public_path__ + "static/media/imagem_06.e3604706.jpg";